import { render } from "./cwc.vue?vue&type=template&id=54b52feb&scoped=true"
import script from "./cwc.vue?vue&type=script&lang=js"
export * from "./cwc.vue?vue&type=script&lang=js"

import "./cwc.vue?vue&type=style&index=0&id=54b52feb&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b52feb"]])

export default __exports__